const style = {
  p: {
    fontSize: `13px`,
    color: `#ce1126`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Contact/style/error.js